<template>
  <div id="zzbf">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'zzbf'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/guide/zzbf/Zzbf.vue